<template>
  <div class="instructions">
    <p>The number of hazards in each scene are indicated in the top left  corner.</p>
    <img src="../assets/instructions_2.png" srcset="../assets/instructions_2.png 1x, ../assets/instructions_2@2x.png 2x, ../assets/instructions_2@3x.png" alt="Instructions">
    <Button text="Next" @click.native="goToInstructions3" />
  </div>
</template>

<script>
import Button from '@/components/Button.vue'

export default {
  components: {
    Button
  },
  methods: {
    goToInstructions3() {
      this.$router.push('/instructions-3')
    }
  }
}
</script>

<style lang="scss" scoped>
.instructions {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 75%;

  p {
    font-size: 27px;
    font-weight: bold;
    margin-bottom: 48px;
    margin-top: 0;
  }

  img {
    margin-bottom: 48px;
  }
}

@media (orientation: landscape) {
  .instructions {
    width: 60%;

    p {
      font-size: 21px;
      line-height: 30px;
      margin: 0 auto 15px;
    }

    img {
      display: block;
      margin: 30px auto;
      width: 150px;
    }
  }
}
</style>